import { Box, Typography } from "@mui/material";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const StepsBar = ({ steps, active }) => {
    const {t} = useTranslation(PAGE_APPLICATIONS)
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mt: 4,
                mb: 6,
                gap: 6,
            }}
        >
            {steps.map((label, index) => {
                const isCompleted = index < active;
                const isLastStep = index === steps.length - 1;
                const isActive = index === active && !isLastStep;

                const showCheck = isCompleted || (isLastStep && index === active);

                return (
                    <Box key={index} sx={{ flex: 1, minWidth: 120 }}>
                        {/* TOP LINE */}
                        <Box
                            sx={{
                                height: 3,
                                mb: 1.2,
                                backgroundColor: isActive
                                    ? "#004B88" // active blue
                                    : showCheck
                                        ? "#2E7D32" // completed green
                                        : "#B5C2D1", // inactive gray
                                borderRadius: 1,
                            }}
                        />

                        <Typography
                            sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: isActive
                                    ? "#004B88"
                                    : showCheck
                                        ? "#2E7D32"
                                        : "#7A8BA3",
                            }}
                        >
                            {t("Step")} {index + 1} {showCheck && "✓"}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: 13,
                                color: isActive
                                    ? "#004B88"
                                    : showCheck
                                        ? "#2E7D32"
                                        : "#7A8BA3",
                                mt: 0.5,
                            }}
                        >
                            {label}
                        </Typography>
                    </Box>
                );
            })}

        </Box>
    );
};

export default StepsBar;
